import { post } from './request';

const defaultError = (
  message = 'Unknown Error',
  { cause, lineNumber, fileName = '/src/api/validation.js' } = {},
) => {
  const newError = Error(message, { cause }, fileName, lineNumber);
  console.debug(newError);
  return newError;
};
export async function chinaIdValidation(values) {
  const {
    governmentIDName,
    governmentID,
    country,
    devToolsSettings: { overrideIdValidationResult, validIdResult, duplicateIdResult },
  } = values;

  if (overrideIdValidationResult) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (duplicateIdResult === 'true') {
      return 'Duplicate';
    }
    return validIdResult;
  }

  // Duplicate Check
  const isDuplicate = await post(`/api/checkDuplicateTaxId`, {
    taxId: governmentID,
    country,
  })
    .then((isDuplicate) => {
      return isDuplicate;
    })
    .catch(() => {
      return true;
    });

  if (isDuplicate) {
    return 'Duplicate';
  }

  // If no duplicate, validate the ID
  const { IsSuccessful } = await post('/api/validateChineseGovId', {
    governmentIDName,
    governmentID,
  });

  if (IsSuccessful) {
    return 'Valid';
  } else {
    return 'Invalid';
  }
}

export const validateBankInfo = async (accountInfo) => {
  const {
    DOB: birthdate,
    IDENTITY: residentRegistrationNumber,
    NAME_ON_BANK: userName,
    NAME_BANK: bankname,
    BANK_ACCOUNT: bankAccountNumber,
    BANK_ACCOUNT_TYPE: bankAccountType,
  } = accountInfo;

  const bankInfo = {
    birthdate,
    residentRegistrationNumber,
    userName,
    bankname,
    bankAccountNumber,
    bankAccountType,
  };

  const { responseMessage } = await post('/api/playNice', bankInfo);
  const parsedResponse = parseData(responseMessage);
  if (!responseMessage || !parsedResponse || parsedResponse?.code !== '0000') {
    return { response: false, code: parsedResponse.code };
  } else {
    return { response: true, code: parsedResponse.code };
  }
};

function parseData(data) {
  if (!data) return;
  const array = data.split('|').filter((el) => {
    return el !== '\n';
  });
  const details = array.pop();
  const code = array.pop();
  const orderId = array.pop();
  return { details, orderId, code };
}
